<template>
    <div class="member_left">
        <div class="hd">
            <h3>个人中心</h3>
            <div class="face">
                <img src="../../assets/images/member/face.png" alt="" width="85" height="85">
            </div>
            <div class="desc">
                <p>
                    账户名称：{{account}}
                </p>
                <!-- <p v-if="expire_time">
                    到期时间：{{formatTimestamp()}}
                </p> -->
            </div>
        </div>
        <div class="bd">
            <div class="bd-menu">
                <div class="item" :class="active_index == 0 ? 'active' : ''" @click="$router.push('/member/index')">
                    <i class="icon-pwd"></i>
                    <span>修改密码</span>
                </div>
                <!-- <div class="item" :class="active_index == 1 ? 'active' : ''" @click="$router.push('/member/recharge')">
                    <i class="icon-recharge"></i>
                    <span>充值会员</span>
                </div> -->
                <!-- <div class="item" :class="active_index == 2 ? 'active' : ''" @click="$router.push('/member/share')">
                    <i class="icon-share"></i>
                    <span>分享赚钱</span>
                </div> -->
                <div class="item" @click="exit">
                    <i class="icon-exit"></i>
                    <span>退出登录</span>
                </div>
            </div>
            <div class="bd-ft">
                <!-- <p>
                    <a @click="openKefu" class="kefu">在线客服</a>
                </p> -->
                <p>
                    当前版本：{{config.version}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>    
    import { mapGetters, mapActions } from 'vuex';
    import { getConfig } from '@/api/config.js';
    import { timestampToTime } from '@/utils/common.js'
    export default {
        data() {
            return {
                active_index: 0,
                config:{}
            };
        },
        watch:{
            $route: {
                handler: function(){
                    switch (this.$route.name) {
                        case 'memberIndex':
                            this.active_index = 0;
                            break;
                        case 'memberRecharge':
                            this.active_index = 1;
                            break;
                        case 'memberShare':
                            this.active_index = 2;
                            break; 
                    }
                },
                immediate: true
            },
            token: {
                handler: function(val){
                    if(val == undefined || val.length < 10) {
                        this.$router.push('/');
                    }
                },
                immediate: true
            }
        },
        computed: {
            ...mapGetters(['token','account','expire_time'])
        },
        created() {
            this.getConfig();
        },
        methods: {
            ...mapActions(['logOut','getUserinfo']),
            getConfig() {
                getConfig().then((response)=>{
                    this.config = response.data.data;
                })
            },
            formatTimestamp() {
                if(this.expire_time) {
                    return timestampToTime(this.expire_time);
                }
            },
            openKefu() {
                // let url = this.config.kefu,
                //     left = (document.documentElement.clientWidth - 950) / 2,
                //     top = (document.documentElement.clientHeight - 600) / 2;
                // window.open(url, 'customeService', 'width=950,height=600,top=' + top + ',left=' + left);
                this.$confirm("和dasd", '',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'

                });
            },
            exit() {
                this.$confirm('确定退出吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message.success('成功');
                    this.logOut();
                    this.$router.push('/');
                }).catch(() => {
                    ;          
                });
            }
        }
    }
</script>

<style lang="scss">
    .member_left {        
        width: 246px;
        box-sizing: border-box;
        color: #88522a;
        .hd {
            border: 1px solid #DDA76B;
            box-sizing: border-box;
            background: #FAEADA;
            min-height: 180px;
            text-align: center;
            padding-bottom: 10px;
            h3 {
                font-size: 20px;
                line-height: 45px;
                font-weight: 500;
            }
            .face {
                img {
                    border-radius: 20px;
                    overflow: hidden;
                }
            }
            .desc {
                text-align: left;
                margin-left: 20px;
                p {
                    font-size: 14px;
                    line-height: 25px;
                }
            }
        }
        .bd {
            border: 1px solid #DDA76B;
            box-sizing: border-box;
            background: #FAEADA;
            margin-top: 10px;
            min-height: 450px;
            position: relative;
            .item {
                height: 50px;
                display: flex;
                align-items: center;
                padding-left: 25px;
                box-sizing: border-box;
                cursor: pointer;
                font-size: 16px;
                box-shadow: 0 1px 0 rgba(255,255,255,0.9) inset,0 -1px 0 rgba(219,167,107,0.9) inset;
                i {
                    background-repeat: no-repeat;
                    background-position: center center;
                    height: 40px;
                    width: 40px;
                    display: inline-block;
                    &.icon-pwd {
                        background-image: url('../../assets/images/member/pwd_sel.png');
                    }
                    &.icon-share {
                        background-image: url('../../assets/images/member/share_sel.png');
                    }
                    &.icon-recharge {
                        background-image: url('../../assets/images/member/recharge_sel.png');
                    }
                    &.icon-exit {
                        background-image: url('../../assets/images/member/exit_sel.png');
                    }
                }
                &.active,&:hover {
                    color: #ffffff;
                    background: linear-gradient(to right,#7A4E1F, #BF7D1F);
                    i {
                        &.icon-pwd {
                            background-image: url('../../assets/images/member/pwd.png');
                        }
                        &.icon-share {
                            background-image: url('../../assets/images/member/share.png');
                        }
                        &.icon-recharge {
                            background-image: url('../../assets/images/member/recharge.png');
                        }
                        &.icon-exit {
                            background-image: url('../../assets/images/member/exit.png');
                        }
                    }
                }
            }
            .bd-ft {
                position: absolute;
                bottom: 10px;
                line-height: 25px;
                color: #88522a;
                left: 35px;
                .kefu {
                    text-decoration: underline;
                    cursor: pointer;
                    color: #88522a;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/member/left.vue